/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NumerologyRequest = {
    /**
     * Full name of the person
     */
    fullName: string;
    /**
     * Date of birth in YYYY-MM-DD format
     */
    dob: string;
    /**
     * Phone number
     */
    phoneNumber: string;
    /**
     * Email address
     */
    email?: string;
    /**
     * Gender of the person
     */
    gender?: NumerologyRequest.gender;
    /**
     * Time of birth in HH:mm format (24-hour)
     */
    birthTime?: string;
    /**
     * Place of birth
     */
    birthPlace?: string;
};
export namespace NumerologyRequest {
    /**
     * Gender of the person
     */
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        OTHER = 'other',
    }
}

